import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 草稿箱按钮 */
const DraftsButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

DraftsButton.defaultProps = {
  icon: ICON_COLLECTION.DRAFTS,
  text: '草稿箱',
};

export default DraftsButton;
